import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ShareSurveyAccessDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    addSurveyDelegates(surveyInstanceId: number, emails: string, note: string, userAccountId: number) {
        const params = new HttpParams()
            .set('userAccountId', userAccountId.toString())
            .set('delegateEmails', emails)
            .set('note', note);
        const addSurveyDelegatesUrl = ecorEnv.apiEndpoint + '/secure/surveys/' + surveyInstanceId + '/delegates/requests';
        return this.httpClient.post<any>(addSurveyDelegatesUrl, null, { params });
    }

    getSurveyDelegates(surveyInstanceId: number) {
        const getSurveyDelegatesUrl = `${ecorEnv.apiEndpoint}/secure/surveys/${surveyInstanceId}/delegates/requests`;
        return this.httpClient.get<any>(getSurveyDelegatesUrl);
    }

    handleDelegation(action: string, requestMapping: string, surveyDelegationRequestId: number, userAccountId: number): Observable<any> {
        const params = new HttpParams()
            .set('action', action)
            .set('removerUserAccountId', userAccountId.toString());
        const handleDelegationUrl = ecorEnv.apiEndpoint + '/' + requestMapping + '/' + surveyDelegationRequestId;
        return this.httpClient.post<any>(handleDelegationUrl, null, { params });
    }
}
